<!--新增/编辑货源码-->
<template>
  <div class="stockCode-add-wrap">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item :to="{ path: '/stockCodeManage' }">
        <i class="iconfont icon_home icon-t-1"></i>
        <span>货源码</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/stockCodeManage' }">货源码管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ `${formType == 'edit' ? '编辑' : '新增'}货源码` }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="stockCode-add-con">
      <div class="ml-5" v-if="this.formType != 'edit'">
        <label>货源码类型&nbsp;&nbsp;</label>
        <el-select v-model="createToApp" placeholder="请选择">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="ml-5 mt-20">
        <label>货源码名称</label>
        <el-input
          id="auto-0"
          :maxlength="32"
          class="input-custom"
          v-model.trim="stockQrName"
          placeholder="请输入货源码名称"
        ></el-input>
        <span class="tip">货源码名称可自定义，如线路名称等</span>
      </div>
      <div class="ml-5 mt-20 clearfix">
        <label :class="formType == 'edit' ? 'fl mt-15' : ''">货源二维码</label>
        <el-button
          v-if="formType == 'add'"
          :disabled="!stockQrName"
          type="primary"
          class="ml-10"
          @click="getCode"
          id="auto-1"
          >生成货源码</el-button
        >

        <img width="200" height="200" id="auto-2" v-if="formType == 'edit' && qrcodeUrl" :src="qrcodeUrl" />
      </div>
    </div>
    <div class="stockCode-add-btn" v-if="formType == 'edit'">
      <el-button type="primary" @click="save" id="auto-3">保存</el-button>
      <el-button @click="saveOff" id="auto-4">取 消</el-button>
    </div>
    <el-dialog custom-class="qrcode-dialog" title="货源二维码" :visible.sync="dialogVisible">
      <img v-if="qrcodeUrl" :src="qrcodeUrl" />

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:4
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from '@/api/axiosNew';
import api from '@/api/base.new.api';
import { commonEventTracking } from '@/utils';

export default {
  data() {
    return {
      stockQrId: '', // 货源码id
      stockQrName: '', // 货源码名称
      createToApp: false, //货源码类型
      qrcodeUrl: '', // 货源二维码
      qrcodeStatus: true, // 二维码生成状态
      formType: 'add',
      dialogVisible: false,
      options: [
        {
          value: false,
          label: '微信/APP'
        },
        {
          value: true,
          label: 'APP'
        }
      ]
    };
  },
  created() {
    commonEventTracking('addStockCodePage', 'page', 'pltUserBehavior');
    this.stockQrId = this.$route.query.key || '';
    if (this.stockQrId) {
      this.formType = 'edit';
      this.featchData();
    }
  },
  methods: {
    featchData() {
      axios.post(api.selectStockQrDetailById, { id: this.stockQrId }).then(res => {
        this.stockQrName = res.data.stockQrName;
        this.qrcodeUrl = res.data.qrCodeWechatUrl;
      });
    },
    getCode() {
      // 生成货源码
      if (this.$route.query.surplusCount == 0 && this.createToApp == false) {
        this.$message.error('添加的"微信/APP"类型货源码个数已经达到上限');
      } else {
        axios
          .post(api.createStockQr, {
            stockQrName: this.stockQrName,
            createToApp: this.createToApp
          })
          .then(res => {
            this.stockQrId = res.data.id;
            this.qrcodeUrl = res.data.qrCodeWechatUrl;
            this.dialogVisible = true;
          });
      }
    },
    // 保存
    save() {
      if (!this.stockQrName) {
        this.$message.error('货源码名称不能为空');
        return false;
      }
      let postData = { id: this.stockQrId };
      let url = api.saveStockQr;
      if (this.formType == 'edit') {
        url = api.updateStockQr;
        postData.stockQrName = this.stockQrName;
      }
      axios.post(url, postData).then(res => {
        if (this.formType == 'add') {
          commonEventTracking('addStockCodePageSaveBtn', 'btn', 'pltUserBehavior', res, {
            stockType: this.createToApp ? 'APP' : '微信/APP'
          });
        }
        this.$message.success('操作成功');
        this.$router.push({ path: '/stockCodeManage' });
      });
    },
    saveOff() {
      this.$router.push({ path: '/stockCodeManage' });
    }
  }
};
</script>
<style>
.stockCode-add-wrap .input-custom {
  margin: 0 0 0 10px;
  width: 200px;
}
.stockCode-add-wrap .tip {
  margin: 0 0 0 5px;
  color: #999;
  font-size: 12px;
}
.stockCode-add-wrap .qrcode-box {
  margin: 20px;
  width: 200px;
  height: 200px;
}
.stockCode-add-wrap .qrcode-box span,
.stockCode-add-wrap .qrcode-box img {
  display: inline-block;
  width: 100%;
  height: 100%;
}
.stockCode-add-wrap .qrcode-box span {
  border: 1px solid #ccc;
}
.stockCode-add-wrap .qrcode-dialog {
  width: 300px;
}
.stockCode-add-wrap .qrcode-dialog img {
  display: block;
  width: 200px;
  height: 200px;
  margin: 10px auto;
}
.stockCode-add-con {
  padding: 10px 15px;
  background: #fff;
}
.stockCode-add-btn {
  padding: 10px 15px;
  background: #fff;
  margin-left: 20px;
}
</style>
